import { render, staticRenderFns } from "./CustomCurve.vue?vue&type=template&id=28ac0952"
import script from "./CustomCurve.vue?vue&type=script&lang=js"
export * from "./CustomCurve.vue?vue&type=script&lang=js"
import style0 from "./CustomCurve.vue?vue&type=style&index=0&id=28ac0952&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports